import { useState, useEffect } from 'react';
import { EmployeeServiceResponse } from '@/api/generated/api';
import { employeesApi } from '@/api/api';

interface UseEmployeeServicesReturn {
  services: EmployeeServiceResponse[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useEmployeeServices = (employeeId: string | null): UseEmployeeServicesReturn => {
  const [services, setServices] = useState<EmployeeServiceResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchServices = async () => {
    if (!employeeId) {
      setServices([]);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);
    
    try {
      const response = await employeesApi.getEmployeeServices({ id: employeeId });
      setServices(response.data);
    } catch (err) {
      console.error('Chyba při načítání služeb zaměstnance:', err);
      setError(err instanceof Error ? err.message : 'Nepodařilo se načíst služby zaměstnance');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, [employeeId]);

  return {
    services,
    isLoading,
    error,
    refetch: fetchServices,
  };
};
